module.exports = __webpack_public_path__ + "img/title-three.30eb6304.png";